import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { lazy } from 'react'
import FormationDashboardContainer from './FormationDashboard/FormationDashboardContainer/FormationDashboardContainer'

const FormationPage = lazy(
  () =>
    import(
      './FormationDashboard/FormationDashboardContainer/FormationDashboardContainer'
    )
)

export default {
  path: '/services',
  exact: false,
  Component: WithPermission(FormationPage, ['page:services'], true),
  access: 'USER',
  routes: [
    {
      path: `/services/formation`,
      exact: true,
      Component: FormationDashboardContainer,
      access: 'USER',
    },
  ],
}
